/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiVehicleInsurance
 */
export interface ApiVehicleInsurance {
    /**
     * 
     * @type {boolean}
     * @memberof ApiVehicleInsurance
     */
    verified: boolean;
}

export function ApiVehicleInsuranceFromJSON(json: any): ApiVehicleInsurance {
    return ApiVehicleInsuranceFromJSONTyped(json, false);
}

export function ApiVehicleInsuranceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiVehicleInsurance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'verified': json['verified'],
    };
}

export function ApiVehicleInsuranceToJSON(value?: ApiVehicleInsurance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'verified': value.verified,
    };
}

